<h1 class="matp-page-title">デバイス種類一覧</h1>

<!-- デバイス種類一覧 -->
<mat-card class="matp-card">
  <div class="tw-bg-white tw-min-w-min">
    <app-device-type-list-table
      [deviceTypeList]="deviceTypeList"
      (created)="openDeviceTypeEditDialog()"
      (updated)="openDeviceTypeEditDialog($event)"
      (deleted)="deleteDeviceType($event)"
    ></app-device-type-list-table>
  </div>
</mat-card>
